

















import Vue from 'vue';

export default Vue.extend({
  name: 'SendErrorModal',
  props: {
    visible: Boolean,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
});
